import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { GlobalSpinnerService } from '@nx-customer-apps/components';
import { Observable } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
    private globalSpinnerService = inject(GlobalSpinnerService);

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
        request = request.clone();
        const request$ = next.handle(request);
        return request$.pipe(
            takeUntil(this.globalSpinnerService.isCanceled$()),
            finalize(() => {
                this.globalSpinnerService.reset();
            })
        );
    }
}
